import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './CardList.css'

export default function GameList() {
    const { mode } = useTheme()

    return (
        <div className='card-list game'>
                <div className={`card ${mode}`}>
                    <h3>Memory Game</h3>
                    <div className='icon-container'>
                        <img src="https://i.imgur.com/P4rsbk3.png" alt="memory game icon" className="card-icon"/>
                    </div>
                    <div className='date'>2024</div>
                    <Link to="/memory-game">Learn More</Link>
                </div>

                <div className={`card ${mode}`}>
                    <h3>Binary Breakout Game</h3>
                    <div className='icon-container'>
                        <img src="https://i.imgur.com/oEPvhnv.png" alt="binary breakout game icon" className="card-icon"/>
                    </div>
                    <div className='date'>2024</div>
                    <Link to="/binary-breakout">Learn More</Link>
                </div>

                <div className={`card ${mode}`}>
                    <h3>Psychward The Game - A Visual Novel</h3>
                    <div className='icon-container'>
                        <img src="https://i.imgur.com/iJdYBms.png" alt="psych ward game icon" className="card-icon"/>
                    </div>
                    <div className='date'>2025</div>
                    <Link to="/psychward">Learn More</Link>
                </div>
        </div>
    )
}